import { CaseNoConsentActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { GetProviderReportsAction } from './providerReport-actions';

export interface GetCaseNoConsentsAction {
    type: typeof CaseNoConsentActions.FETCH_CASE_NO_CONSENTS;
    payload: QueryParams;
    all?: any;
}

export function getCaseNoConsents(params: QueryParams): GetCaseNoConsentsAction {
    return {
        type: CaseNoConsentActions.FETCH_CASE_NO_CONSENTS,
        payload: params,
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getCaseNoConsentsCsv(params: QueryParamsAll): GetProviderReportsAction {
    return {
        type: CaseNoConsentActions.FETCH_CASE_NO_CONSENTS_CSV,
        payload: params,
    };
}

export interface GetCaseNoConsentAction {
    type: typeof CaseNoConsentActions.FETCH_CASE_NO_CONSENT;
    payload: {
        id: string | number;
    };
}

export function getCaseNoConsent(id: string | number): GetCaseNoConsentAction {
    return {
        type: CaseNoConsentActions.FETCH_CASE_NO_CONSENT,
        payload: { id },
    };
}

export interface DeleteCaseNoConsentAction {
    type: typeof CaseNoConsentActions.DELETE_CASE_NO_CONSENT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteCaseNoConsent(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteCaseNoConsentAction {
    return {
        type: CaseNoConsentActions.DELETE_CASE_NO_CONSENT,
        payload: { id, onSuccess, onError },
    };
}
/*

export interface PersistCaseNoConsentAction {
    type: typeof CaseNoConsentActions.PERSIST_CASE_NO_CONSENT;
    payload: {
        data: CaseNoConsentFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistCaseNoConsent(
    data: CaseNoConsentFormData,
    callbacks: SagaPromise<any>,
): PersistCaseNoConsentAction {
    return {
        type: CaseNoConsentActions.PERSIST_CASE_NO_CONSENT,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistCaseNoConsent = (data: CaseNoConsentFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistCaseNoConsent(data, { resolve, reject }));
    });
};
*/

export type Actions = GetCaseNoConsentsAction | GetCaseNoConsentAction | DeleteCaseNoConsentAction;
